export interface OfertaRequest{
    nombre:string,
    tipo:string,
    valor:number,
    fechaInicio:Date,
    fechaFin:Date | null,
    aplicaA:string,
    detalles:OfertaDetalleItemRequest[],
}
export interface OfertaDetalleItemRequest{
    referenciaId:string,
    tipoReferencia:string,
}
export interface UpdateOfertaRequest{
    id:string,
    nombre:string | null,
    valor:number | null,
    fechaInicio:Date | null,
    fechaFin:Date | null,
    status:string | null,
    detallesNuevos:OfertaDetalleItemRequest[] | null,
}
export interface OfertaDetalleResponse {
    referenciaId:string,
    tipoReferencia:string,
    nombreReferencia:string | null,
}
export interface OfertaResponse{
    id:string,
    nombre:string,
    tipo:string,
    valor:number,
    fechaInicio:Date,
    fechaFin:Date | null,
    status:string | null,
    aplicaA:string,
    detalles:OfertaDetalleResponse[],
}

export interface OfertasState {
    ofertas: OfertaResponse[];
}

export const SET_OFERTAS = 'SET_OFERTAS';

export interface SetOfertasAction {
    type: typeof SET_OFERTAS;
    payload: OfertaResponse[];
}

export type OfertasActionTypes = SetOfertasAction;